// src/config/departments.ts
import LogisticsIcon from '../assets/Icons/Logistics.png';
import SecurityIcon from '../assets/Icons/Security.png';
import ExplorationIcon from '../assets/Icons/Exploration.png';
import MedicalIcon from '../assets/Icons/Medical.png';

export interface DepartmentConfig {
  id: string; // URL-safe identifier
  name: string;
  icon?: string;          // optional emoji fallback
  iconUrl?: string;
  color: string;
  description: string;
  modules: Array<"roster" | "briefing" | "calendar" | "resources" | "applications" | "videos">;
  bannerImage?: string; // Optional background
  chief?: string; // ✅ Added to support modal
}

export const departments: DepartmentConfig[] = [
{
  id: "operations",
  name: "Operations",
  iconUrl: "/assets/icons/operations.png",
  color: "#6f42c1",
  description:
    "Overall Planning Branch of the organization. This department handles macro strategy, HR, and org member management. Most general operational positions are housed here, while specialized roles are distributed across other departments.",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/operations.jpg",
  chief: "Chief Operations Officer"
},
{
  id: "logistics",
  name: "Logistics",
  iconUrl: LogisticsIcon,
  color: "#1e90ff",
  description:
    "Handles all movement of goods/services. Also comprised of industrial operations and logistics management",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/logistics.jpg",
  chief: "Chief Logistics Officer"
},
{
  id: "security",
  name: "Security",
  iconUrl: SecurityIcon,
  color: "#dc3545",
  description:
    "Responsible for escort, security, and tactical superiority during ops. All combat operations flow from and through this department",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/security.jpg",
  chief: "Chief Security Officer"
},
{
  id: "exploration",
  name: "Exploration",
  iconUrl: ExplorationIcon,
  color: "#6f42c1",
  description:
    "All discovery, scouting, exploration and intelligence operations are managed within this dept.",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/exploration.jpg",
  chief: "Chief Exploration Officer"
},
{
  id: "intelligence",
  name: "Intelligence",
  iconUrl: "/assets/icons/intelligence.png",
  color: "#6f42c1",
  description:
    "All clandestine operations are managed in this dept. A secret dept of the organization designed to provide intel and counter intelligence for our security and expansion",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/intelligence.jpg",
  chief: "Chief Intelligence Officer"
},
{
  id: "technology",
  name: "Technology",
  iconUrl: "/assets/icons/technology.png",
  color: "#6f42c1",
  description:
    "Department tasked with understanding every technical aspect of the verse. Answering questions about 'how does it work', and what are the best tools for any job, etc...",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/technology.jpg",
  chief: "Chief Technology Officer"
},
{
  id: "medical",
  name: "Medical",
  iconUrl: MedicalIcon,
  color: "#1e90ff",
  description:
    "Provides medical support, field treatment, and biomedical research for the org.",
  modules: ["briefing", "roster", "calendar", "resources", "applications", "videos"],
  bannerImage: "/assets/medical.jpg",
  chief: "Chief Medical Officer"
}
];